import { clsx } from 'clsx';
import { createPortal } from 'react-dom';

import cn from './styles.module.scss';

interface ILoaderProps {
    mini?: boolean;
    fullScreen?: boolean;
}

export const Loader = ({ mini, fullScreen }: ILoaderProps) => {
    return fullScreen ? (
        createPortal(
            <div className={cn.wrapper}>
                <div
                    className={clsx(cn.loader, mini && cn.mini, fullScreen && cn.fullScreen)}
                ></div>
            </div>,
            document.body
        )
    ) : (
        <div className={clsx(cn.loader, mini && cn.mini, fullScreen && cn.fullScreen)}></div>
    );
};
